import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=19bd4354"
import script from "./SideMenu.ts?vue&type=script&lang=ts&external"
export * from "./SideMenu.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports